module.exports = __webpack_public_path__ + "static/media/bannerImg.20b0a741.png";